module.exports = __webpack_public_path__ + "static/img/hzhb_lb.501c8e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_lb.png
// module id = lUFo
// module chunks = 0